import { rankingData } from "@/mocks/homeData";

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-50 text-center mb-2">热门排行</h2>
        <p className="text-foreground-500 text-sm text-center mb-8 md:mb-10">本周最受欢迎影视内容 TOP 7</p>
        <div className="space-y-2">
          {rankingData.map((item) => (
            <a
              key={item.rank}
              href="#carousel"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#carousel")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-background-50 rounded-lg border border-background-200/50 hover:border-primary-500/20 transition-all duration-300 cursor-pointer group"
            >
              <span
                className={`w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full flex-shrink-0 text-sm md:text-base font-heading ${
                  item.rank <= 3
                    ? "bg-primary-500 text-background-950"
                    : "bg-secondary-100/50 text-secondary-300"
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-foreground-200 text-sm md:text-base font-medium truncate group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs">{item.type}</p>
              </div>
              <span className="text-primary-500 text-sm md:text-base font-heading whitespace-nowrap">{item.score}</span>
              <span className="px-2 py-0.5 bg-accent-500/20 text-accent-400 text-xs rounded-full whitespace-nowrap hidden sm:inline-block">
                {item.tag}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}